import axios from "axios";

const RAW_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const API_ROOT = RAW_BASE.match(/\/api$/i) ? RAW_BASE : `${RAW_BASE}/api`;
const API_URL = `${API_ROOT}/proveedoresfacturas`;

export const obtenerFacturasProveedor = ({
  pageNumber = 1,
  pageSize = 20,
  search = "",
  estatus = "",
  idProveedor = "",
  anio,
  mes,
} = {}) =>
  axios.get(API_URL, {
    params: {
      pageNumber,
      pageSize,
      search: (search || "").trim(),
      estatus: estatus === "" ? undefined : estatus,
      idProveedor: idProveedor === "" ? undefined : idProveedor,
      // mes=0 significa "Todos" (acumulado del año) — usar ?? en vez de ||
      // porque 0 es falsy en JS y se perdería con ||.
      anio: anio ?? undefined,
      mes: mes ?? undefined,
      empresaId: Number(localStorage.getItem("empresaId") || 0),
    },
  });

export const obtenerFacturaPorId = (idFactura) =>
  axios.get(`${API_URL}/${idFactura}`);

export const crearFacturaProveedor = (data) =>
  axios.post(API_URL, { ...data, empresa: Number(localStorage.getItem("empresaId") || 0) });

export const actualizarFacturaProveedor = (idFactura, data) =>
  axios.put(`${API_URL}/${idFactura}`, data);

export const eliminarFacturaProveedor = (idFactura) =>
  axios.delete(`${API_URL}/${idFactura}`);
